<template>
  <div>
    <v-menu offset-y :nudge-bottom="8" v-model="internalMemu">
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <FunctionizeLogo class="text-white" />
        </v-btn>
      </template>
      <v-list class="header-right-teamswitch-dropdown bg-white">
        <v-list-item-group>
          <v-list-item>
            <router-link class="text-main fs-13" :to="{ name: 'JsonViewer' }" target="_blank">
              Json Viewer
            </router-link>
          </v-list-item>
          <v-list-item>
            <router-link class="text-main fs-13" :to="{ name: 'InternalTools' }" target="_blank">
              Internal Tools
            </router-link>
          </v-list-item>
          <v-list-item>
            <router-link class="text-main fs-13" :to="{ name: 'Encoder' }" target="_blank">
              Encoder
            </router-link>
          </v-list-item>
          <v-list-item link href="https://www.functionizeapp.com/tools/emailreader" target="_blank">
            <span class="text-main fs-13"> Email Reader </span>
          </v-list-item>
          <v-list-item link href="https://www.functionizeapp.com/tools/fileviewer" target="_blank">
            <span class="text-main fs-13"> File Viewer </span>
          </v-list-item>
          <v-list-item link href="https://www.functionizeapp.com/tools/apiexplorer" target="_blank">
            <span class="text-main fs-13"> API Explorer </span>
          </v-list-item>
          <v-list-item v-if="validateUser">
            <router-link
              class="text-main fs-13"
              :to="{ name: 'DiagnosticErrorReport' }"
              target="_blank"
            >
              Diagnostic Error
            </router-link>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapState } from "vuex";
import FunctionizeLogo from "../../assets/svg/functionizeHeaderLogo.svg";

export default {
  name: "InternalPages",
  components: { FunctionizeLogo },
  data: () => ({
    internalMemu: false,
  }),
  computed: {
    ...mapState({
      window: (state) => state.window,
    }),
    validateUser() {
      let userIdArray = this.window.allowedUsersForDstError;
      if (this.window.top_user_id && userIdArray.indexOf(this.window.top_user_id) > -1) {
        return true;
      }
      return false;
    },
  },
  methods: {},
  created() {},
  watch: {},
};
</script>

<style scoped>
svg.text-white path {
  fill: white;
}
</style>
